import React, { useCallback, useEffect, useRef,useState } from "react";

import EasyCrop from "react-easy-crop";

import styles from "./CouponImageCropper.module.scss";

const getCroppedImage = async (imageSrc, cropPixels) => {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = imageSrc;
  await new Promise(r => (img.onload = r));

  const canvas = document.createElement("canvas");
  canvas.width = cropPixels.width;
  canvas.height = cropPixels.height;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(
    img,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    cropPixels.width,
    cropPixels.height
  );

  return new Promise(resolve =>
    canvas.toBlob(blob => resolve(blob), "image/jpeg")
  );
};

const CouponImageCropper = ({ image, onSave, onClose }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedPixels, setCroppedPixels] = useState(null);
  const [currentImage, setCurrentImage] = useState(image);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setCurrentImage(image);
  }, [image]);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedPixels(croppedAreaPixels);
  }, []);

  const minZoom = 1;
  const maxZoom = 3;

  const handleFileUpload = e => {
    const file = e.target.files?.[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    setCurrentImage(url);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  };

  const handleApply = async () => {
    if (!croppedPixels || !currentImage) return;
    const blob = await getCroppedImage(currentImage, croppedPixels);
    const url = URL.createObjectURL(blob);
    onSave({ blob, url });
  };

  return (
    <div className={styles.container}>
      <div className={styles.cropArea}>
        {currentImage && (
          <EasyCrop
            image={currentImage}
            crop={crop}
            zoom={zoom}
            aspect={4/3}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            minZoom={minZoom}
            maxZoom={maxZoom}
            objectFit="contain"
          />
        )}
      </div>

      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        className={styles.hiddenInput}
        onChange={handleFileUpload}
      />

      <div className={styles.controls}>
        <input
          type="range"
          min={minZoom}
          max={maxZoom}
          step={0.05}
          value={zoom}
          onChange={e => setZoom(Number(e.target.value))}
          className={styles.zoomSlider}
        />

        <div className={styles.buttons}>
          <button
            className={styles.button}
            onClick={() => fileInputRef.current.click()}
          >
            Upload Image
          </button>

          <button className={styles.button} onClick={handleApply}>
            Apply Crop
          </button>

          <button className={styles.button} onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CouponImageCropper;
